import { Component } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-save-conversation-modal',
    templateUrl: './save-conversation-modal.component.html',
    styleUrls: ['./save-conversation-modal.component.css'],
    standalone: false
})
export class SaveConversationModalComponent {
  conversationName: string = '';

  constructor(private modal: NzModalRef) {}

  handleOk(): void {
    if (!this.conversationName.trim()) {
      return;
    }
    this.modal.close(this.conversationName.trim());
  }

  handleCancel(): void {
    this.modal.destroy();
  }
}

